<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
  <p-toast position="bottom-right" key="br"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>
          {{ 'DeliveryNotes_Title' | translateWF: 'Delivery Notes' }}
        </h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-button [label]="'Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="redirectToDetails('new')" />
          }
        </div>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'DeliveryNotes_Title' | translateWF: 'Delivery Notes'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table
            [value]="listDeliveryNotes()"
            dataKey="id"
            [paginator]="true"
            [rows]="25"
            [rowsPerPageOptions]="[15, 25, 50, 100]"
            paginatorDropdownAppendTo="body"
            [sortOrder]="1"
            selectionMode="single"
            [first]="firstPagination()"
            (onPage)="onPageChange($event)"
            [customSort]="true"
            (sortFunction)="onTableSort($event)"
          >
            <ng-template pTemplate="header">
              <tr class="cs-datatable-header-dark">
                <th pSortableColumn="number">
                  {{ 'DeliveryNotes_Number' | translateWF: 'Delivery Note Number' }}
                  <p-sortIcon field="number"></p-sortIcon>
                </th>
                <th>
                  {{ 'DeliveryNotes_Client_Document_Reference' | translateWF: 'Client Document Reference' }}
                </th>
                <th>
                  {{ 'DeliveryNotes_Work_Orders' | translateWF: 'Work Orders Associated' }}
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-index="rowIndex">
              @let deliveryNote = getRowData(rowData);
              <tr class="cursor-pointer" (click)="redirectToDetails(deliveryNote.id!)">
                <td>
                  <a>{{ deliveryNote?.number }}</a>
                </td>
                <td>
                  {{ deliveryNote?.clientDocumentReference }}
                </td>
                <td>
                  {{ getWorkOrderNumbers(deliveryNote) }}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="3">
                  {{ 'DeliveryNotes_No_Delivery_Notes_Found' | translateWF: 'No delivery notes found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
